import { motion } from "framer-motion";
import { MANIFESTO } from "../lib/data";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="border-b border-black bg-[#0E0E0E] text-[#F4F4F0]">
    <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#F4F4F0]/50 mb-16">( The Manifesto )</p>
      <div className="space-y-0">
        {MANIFESTO.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-t border-[#F4F4F0]/20"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <div className="md:col-span-3">
              <span className="font-display font-bold text-6xl md:text-8xl leading-none" style={{ color: c.color }}>
                {c.num}
              </span>
            </div>
            <div className="md:col-span-5">
              <h3 className="font-display font-semibold uppercase text-2xl sm:text-3xl tracking-tight">{c.title}</h3>
            </div>
            <div className="md:col-span-4">
              <p className="font-mono text-sm leading-relaxed text-[#F4F4F0]/70">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
